import { useTranslation } from "react-i18next";
import { ScrollView, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

import { Text } from "@/components/ui/text";
import { FamilyProfilesSection } from "@/features/profile";

export function FamilyScreen() {
    const { t } = useTranslation();

    return (
        <SafeAreaView className="flex-1 bg-background" edges={["top"]}>
            <View className="items-center pb-4">
                <Text variant="label">{t("family.title")}</Text>
            </View>
            <ScrollView
                className="flex-1"
                contentContainerClassName="gap-6 px-4 pb-6"
            >
                <Text variant="caption">{t("family.subtitle")}</Text>
                <FamilyProfilesSection />
            </ScrollView>
        </SafeAreaView>
    );
}
